<script lang="ts">
const __DsBlock = {
	// hidden: true,
	icon: 'mdi:button-pointer',
	category: 'basic',
	events: [
		{
			name: 'click',
			payload: [],
		},
	],
	options: [
		{
			name: 'label',
		},
		{
			name: 'color',
			type: 'enum',
			values: BLOCK_COLOR_OPTIONS,
		},
		{
			name: 'variant',
			type: 'enum',
			values: ['solid', 'outline', 'soft', 'subtle', 'ghost', 'link'],
		},
		{
			name: 'size',
			type: 'enum',
			values: BLOCK_CONTROL_SIZE_OPTIONS,
		},
		{
			name: 'leadingIcon',
			block: BuiltinBlockIds.InputIcon,
		},
		{
			name: 'trailingIcon',
			block: BuiltinBlockIds.InputIcon,
		},
		{
			name: 'block',
		},
		{
			type: 'separator',
			label: '$t:common.state',
		},
		{
			name: 'loading',
		},
		{
			name: 'disabled',
		},
	],
}
</script>
<script lang="ts" setup>
import type { ButtonProps } from '#layers/ui';
import { BuiltinBlockIds } from 'virtual:monospace-builtin-block-ids';

import { defineBlock } from '#layers/block-engine';
import { BLOCK_COLOR_OPTIONS, BLOCK_CONTROL_SIZE_OPTIONS } from '#layers/blocks/constants/ui-options';
import { useTranslationUtils } from '#layers/i18n';
import { isUrl } from '#layers/ui';

interface ButtonBlockProps extends Pick<
	ButtonProps,
'label' | 'color' | 'variant' | 'size' | 'loading' | 'disabled' | 'block'
> {
	leadingIcon?: string;
	trailingIcon?: string;
}

withDefaults(defineProps<ButtonBlockProps>(), {
	label: 'Button',
});

defineEmits<{
	click: [];
}>();

;

const { translateString } = useTranslationUtils();
</script>

<template>
	<div>
		<DButton
			v-bind="{
				...$props,
				label: translateString(label),
				...leadingIcon && isUrl(leadingIcon) ? {
					avatar: {
						src: leadingIcon,
					},
					leadingIcon: undefined,
				} : {
					leadingIcon,
				},
			}"
			:ui="{
				leadingAvatar: 'rounded-none bg-transparent [&>img]:object-contain',
				base: 'flex',
			}"
			@click="$emit('click')"
		/>
	</div>
</template>
